import Vue from 'vue'
import Vuex from 'vuex'
import VuexAlong from 'vuex-along'

Vue.use(Vuex);

const state = {
  themeImgRootPath: null,
  themeMainColor: '',
  quoteVehicleInfo: null,
  permissions: '',
  channelData: {},
  chatServicePic: null,
  goHomeShow: getGoHomeShow(),
}
const mutations = {
  themeImgRootPath(state, theme) {
    if (undefined == theme || "" == theme) theme = "blue"

    // state.themeImgRootPath = process.env.VUE_APP_BASE_PATH+ "/theme/"+theme+"/";

    state.themeImgRootPath = "/hv2/static/theme/" + theme + "/";
  },
  themeMainColor(state, mainColor) {
    state.themeMainColor = mainColor;
  },
  quoteVehicleInfo(state, info) {
    state.quoteVehicleInfo = info;
  },
  permissionsFn(state, permissions) {
    state.permissions = permissions;
  },
  setChannelData(state, data) {
    state.channelData = data
  },
  setChatServicePic(state, data) {
    state.chatServicePic = data
  },
  setGoHomeShow(state, data) {
    state.goHomeShow = data
  },
};

const store = new Vuex.Store({
  state,
  mutations,
  plugins: [VuexAlong]
});
function getGoHomeShow() {
  const permissions = sessionStorage['permissions'] ? JSON.parse(sessionStorage['permissions']) : []
  return permissions.includes('cs_working')
}
export default store;



// WEBPACK FOOTER //
// ./src/store.js